import { useMemo } from 'react';
import { ListLivestockInsurancePriceDatesResponse } from '../../../../../Generated/Raven-Demeter';
import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import { GeneralRiskCalculationInputs } from '../DairyRevenueProtection/DairyRevenueProtectionDefinitions';

interface IGeneralRiskInsuranceYearDropdownProps {
    calculationInputs: GeneralRiskCalculationInputs;
    setCalculatorInputs: (value: GeneralRiskCalculationInputs) => void;
    listLivestockInsurancePriceDatesResponse: ListLivestockInsurancePriceDatesResponse;
}

const GeneralRiskInsuranceYearDropdown: React.FC<IGeneralRiskInsuranceYearDropdownProps> = (props: IGeneralRiskInsuranceYearDropdownProps) => {
    const [translations] = useLanguage();

    const insuranceYearOptions = useMemo(() => {
        if (!props.listLivestockInsurancePriceDatesResponse) {
            return [];
        }

        return props.listLivestockInsurancePriceDatesResponse.rows!.map((x) => ({
            label: `${x.reinsuranceYear}`,
            value: x.reinsuranceYear,
        }));
    }, [props.listLivestockInsurancePriceDatesResponse]);

    return (
        <Dropdown
            value={props.calculationInputs.insuranceYear}
            options={insuranceYearOptions}
            handleOptionChange={(value) => props.setCalculatorInputs({ ...props.calculationInputs, insuranceYear: value })}
            label={translations.risk.margin.fields.insuranceYear}
            track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'InsuranceYearChanged' }}
        />
    );
};

export default GeneralRiskInsuranceYearDropdown;
